import React from 'react'
import { t } from '../i18n'
import { ArrowUp, Spinner } from './Icons'
import { SourceStack } from './SourceAvatar'

/* "↑ 5 novih vijesti" (spec 5.4): logos of up to 3 sources, centred under
   the sticky chips. Nothing moves until it's clicked. */
export function NewStoriesPill({ count, sources, onClick }) {
  if (!count) return null
  const label = count > 9 ? t('feed.newStoriesMax') : t('feed.newStories', { count })
  return (
    <div className="pill-anchor">
      <button type="button" className="new-pill" onClick={onClick}>
        {sources?.length > 0 && <SourceStack sources={sources} size={18} />}
        <ArrowUp size={15} strokeWidth={2.5} />
        <span>{label}</span>
      </button>
    </div>
  )
}

/* Under the chips/tabs while refreshing, then "Sve je ažurirano…" for ~2 s
   when nothing was new (spec 6). */
export function RefreshRow({ state }) {
  if (!state) return null
  return (
    <div className="refresh-row" role="status" aria-live="polite">
      {state === 'loading' ? (
        <>
          <Spinner size={16} />
          <span>{t('feed.refreshing')}</span>
        </>
      ) : (
        <span>{t('feed.upToDate')}</span>
      )}
    </div>
  )
}
